module.exports = __webpack_public_path__ + "media/customizations/terramor/logo-e2ac57578741348e5ce22cbbf66c381d.png";